import React from 'react';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import { IHSRCharacter } from '../../../common/model/graphql-types';
import { Alert } from 'react-bootstrap';
import { HSRPath } from './hsr-path';
import { HSRElement } from './hsr-element';
import { HSRRarity } from './hsr-rarity';
import { HSRPopoverRatings } from './hsr-popover-ratings';
import { HSRRatings } from '../../data/hsr-ratings';

interface IProps {
  character: IHSRCharacter;
}

export const HSRCharacterPopover: React.FC<IProps> = ({ character }) => {
  const image = character.smallImage
    ? getImage(character.smallImage.localFile.childImageSharp)
    : null;

  const charInfo = HSRRatings.find(
    (char) => char.slug === character.slug && char.default === true
  );
  return (
    <div className="character-popover hsr">
      <div className="top hsr">
        <div className={`avatar hsr rarity-${character.rarity}`}>
          {image && (
            <GatsbyImage
              className="disable-transition"
              image={image}
              alt={`${character.name}`}
            />
          )}
        </div>
        <p className="name">
          <span className="emp-name">{character.name}</span>{' '}
          {character.isNew && <span className="tag new">NEW!</span>}{' '}
        </p>
        <div className="type-class">
          <HSRRarity charClass={character.rarity} />
          <HSRElement charClass={character.element} />
          <HSRPath charClass={character.path} />
        </div>
      </div>
      {!character.isReviewPending ? (
        <>
          <HSRPopoverRatings character={charInfo} />
        </>
      ) : (
        <Alert variant="primary">
          <p>
            This character ratings aren't available because they're not released
            yet.
          </p>
        </Alert>
      )}
    </div>
  );
};
